/*=========================================================================================
  File Name: modulePartnerState.js
  Description: Partner Module State
==========================================================================================*/


export default {
    partner: {},
    partners: [],
    programs: [],
    devices: [],
    programSearchQuery: '',
    programFilter: null,
}
